<template>
  <div>
    <div class="simulator-timer">
      <div class="container">
        <a @click="$emit('show-exit-modal')" class="simulator-comeback">Выйти из симулятора</a>
        <div>Осталось: {{ timeFromSeconds }}</div>
      </div>
    </div>

    <div v-if="!currentQuestion" class="simulator-progress">
      <div class="container">
        <div class="flex">
          <div
            v-for="(question, index) of questions"
            :key="question.id"
            :class="{ passed: index < answeredQuestions.length }"
            class="simulator-progress__item"></div>
        </div>
      </div>
    </div>

    <div class="container">
      <div  v-if="!currentQuestion" class="flex simulator-questions">
        <div v-for="(questionLineColor, lineIndex) of questionsLineColors"
             :key="questionLineColor"
             class="simulator-questions__col" :class="`col-${questionLineColor}`">
          <a
            v-for="(question, questionIndex) of getQuestionLine(lineIndex)"
            :to="`/question/${question.id}`"
            :key="question.id"
            @click="goToQuestion(getQuestionIndex(lineIndex, questionIndex), questionLineColor)"
            :class="{answered: getQuestionStatus(getQuestionIndex(lineIndex, questionIndex)) }"
            class="simulator-questions__item"
            :ref="`question-${getQuestionIndex(lineIndex, questionIndex)}`"
            tabindex="0"
          >
            <span class="number">{{ getQuestionIndex(lineIndex, questionIndex) + 1 }}</span>
            <div class="simulator-questions__content" :class="question.image ? 'content-image' : 'content-text'">
              <img v-if="question.image" :src="`${$APP_URL}/storage/${question.image}`">
              <p v-html="question.text"></p>
            </div>
            <div
              v-if="result.show"
              :class="`result-${getQuestionResult(getQuestionIndex(lineIndex, questionIndex)).className}`"
            >
              {{ getQuestionResult(getQuestionIndex(lineIndex, questionIndex)).text }}
            </div>
          </a>
        </div>
      </div>

      <div v-else class="simulator-question">
        <img v-if="currentQuestion.image" :src="`${$APP_URL}/storage/${currentQuestion.image}`" class="simulator-question__image">
        <div class="simulator-question__text" v-html="currentQuestion.text"></div>
        <form class="simulator-form" @submit.prevent="answerOnQuestion(currentAnswer)">
          <template v-for="(answer, key, index) in getAnswersOfQuestion(currentQuestion)">
            <input
              :ref="`question-input-${index + 1}`"
              type="radio"
              v-model="currentAnswer"
              name="question"
              :value="key"
              class="simulator-option"
              :key="key"
              :id="key"
              :disabled="isQuestionAnswered"
              @click="currentAnswer = key"
            >
            <label :for="key" :key="`${key}-label`">{{ index + 1 }}. {{ answer }}</label>
          </template>

          <div class="flex row-btn">
            <button
              type="submit"
              class="simulator-button"
              :disabled="!currentAnswer || isQuestionAnswered"
              tabindex="-1"
            >Ответить</button>
            <button
              type="button"
              class="simulator-button prev"
              :disabled="currentQuestionIndex === 0"
              @click="goToQuestion(currentQuestionIndex - 1, getLineColorByIndex(currentQuestionIndex - 1))"
              tabindex="-1"
            >К предыдущему</button>
            <button
              type="button"
              class="simulator-button"
              @click="goToQuestionList"
              tabindex="-1"
            >К перечню</button>
            <button
              type="button"
              class="simulator-button next"
              :disabled="currentQuestionIndex === questions.length - 1"
              @click="goToQuestion(currentQuestionIndex + 1, getLineColorByIndex(currentQuestionIndex + 1))"
              tabindex="-1"
            >К следующему</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="result.modal" class="simulator-modal show" id="simulator-success">
      <div class="simulator-modal__body" :class="result.modal.status">
        <div class="simulator-modal__title">{{ result.modal.title }}</div>
        <div class="simulator-modal__text">{{ result.modal.description }}</div>
        <button ref="modal-button" v-if="result.modal.buttonType === 'go-to-addition-questions'" @click="getAdditionQuestions" autofocus class="simulator-button">К дополнительным вопросам</button>
        <button ref="modal-button" v-if="result.modal.buttonType === 'show-errors' && wrongQuestions.length" @click="showFailedQuestions" autofocus class="simulator-button">Посмотреть ошибки</button>
        <button ref="modal-button" v-if="result.modal.buttonType === 'show-errors' && !wrongQuestions.length" @click="endExam" class="simulator-button" autofocus>Завершить экзамен</button>
        <button ref="modal-button" v-if="result.modal.buttonType === 'complete-exam'" class="simulator-button" @click="endExam" autofocus>Завершить экзамен</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QuestionList',
    data() {
      return {
        questionsLineColors: ['green', 'violet', 'blue', 'orange'],
        currentQuestion: null,
        currentQuestionIndex: null,
        currentAnswer: null,
        currentFocusedIndex: 0,
        answeredQuestions: [],
        wrongQuestions: [],
        rightQuestions: [],
        idsForAdditionalQuestions: [],
        isAdditionQuestions: false,
        additionQuestionsErrors: 0,
        timer: {
          id: null,
          left: 0,
          elapsed: 0,
        },
        result: {
          show: false,
          modal: null,
        },
      };
    },
    computed: {
      questions() {
        return this.$store.getters.questions;
      },
      timeFromSeconds() {
        return (new Date(this.timer.left * 1000)).toTimeString().replace(/.*(\d{2}:\d{2}).*/, '$1');
      },
      elapsedTimeFormat() {
        return (new Date(this.timer.left * 1000)).toTimeString().replace(/.*(\d{2}:\d{2}).*/, '$1');
      },
      isQuestionAnswered() {
        return !!this.getAnswerOnCurrentQuestion();
      },
    },
    methods: {
      getQuestionIndex(lineNumber, lineIndex) {
        return (5 * lineNumber) + lineIndex;
      },
      getQuestions() {
        this.$store.dispatch('getExamQuestions', {
          type: 2,
          id: 1,
          isSimulator: true,
        })
          .then(() => {
            this.initQuestions();
          });
      },
      initQuestions() {
        this.timer.left = this.questions.length * 60;
        this.$refs[`question-${this.currentFocusedIndex}`][0].focus();
        this.startTimer();
      },
      startTimer() {
        this.timer.id = setInterval(() => {
          this.timer.left--;
          this.timer.elapsed++;

          if (this.timer.left <= 0) {
            this.stopTimer();
            this.calculateResults();
          }
        }, 1000);
      },
      stopTimer() {
        clearInterval(this.timer.id);
        this.timer.id = null;
      },
      getQuestionLine(lineIndex) {
        return this.questions.slice(5 * lineIndex, (5 * lineIndex) + 5);
      },
      goToQuestionList() {
        this.currentQuestion = null;

        if (this.answeredQuestions.length === this.questions.length) {
          this.calculateResults();
        }
      },
      showResults() {
        this.stopTimer();
        this.currentQuestion = null;
        this.result.show = true;
      },
      setFailedModal() {
        this.showResults();

        this.result.modal = {
          status: 'failed',
          title: 'Экзамен не сдан',
          description: 'Для просмотра экзаменационных билетов с комментариями нажмите клавишу “Enter” на клавиатуре.',
          buttonType: 'show-errors',
        };
      },
      setSuccessModal() {
        this.showResults();

        this.result.modal = {
          status: 'success',
          title: 'Экзамен сдан',
          description: '',
          buttonType: 'complete-exam',
        };
      },
      setErrorModal(errors) {
        this.showResults();

        this.result.modal = {
          status: 'error',
          title: errors === 1 ? 'Вами была допущена ошибка' : 'Вами были допущены 2 ошибки',
          description: 'Чтобы завершить экзамен, нужно ответить на дополнительные вопросы.',
          buttonType: 'go-to-addition-questions',
        };
      },
      getLineColorByIndex(index) {
        let blockColor = '';

        if (index <= 4) {
          blockColor = 'green';
        } else if (index >= 5 && index <= 9) {
          blockColor = 'violet';
        } else if (index >= 10 && index <= 14) {
          blockColor = 'blue';
        } else {
          blockColor = 'orange';
        }

        return blockColor;
      },
      calculateResults() {
        const oneErrorInBlock = [];
        const errors = {
          green: [],
          violet: [],
          blue: [],
          orange: [],
        };

        for (const [questionIndex, question] of this.questions.entries()) {
          const blockColor = this.getLineColorByIndex(questionIndex);
          let isQuestionAnswered = false;

          errors[blockColor].push(question);

          for (const answeredQuestion of this.answeredQuestions) {
            if (questionIndex === answeredQuestion.index) {
              isQuestionAnswered = true;

              if (answeredQuestion.correct) {
                errors[blockColor].splice(-1, 1);
              }
            }
          }

          if (!isQuestionAnswered) {
            this.wrongQuestions.push(question);
          }
        }

        for (const block in errors) {
          if (errors[block].length === 1) {
            oneErrorInBlock.push({
              block,
              questionId: errors[block][0].id,
            });
          } else if (errors[block].length > 1) {
            this.setFailedModal();
            return;
          }
        }

        if (oneErrorInBlock.length === 0) {
          this.setSuccessModal();
        } else if (oneErrorInBlock.length === 1 || oneErrorInBlock.length === 2) {
          this.idsForAdditionalQuestions = oneErrorInBlock;
          this.setErrorModal(oneErrorInBlock.length);
        } else {
          this.setFailedModal();
        }
      },
      goToQuestion(index, lineColor) {
        this.currentQuestionIndex = index;
        this.currentQuestion = this.questions[this.currentQuestionIndex];
        this.currentQuestion.lineColor = lineColor;
        this.currentAnswer = this.isQuestionAnswered ? this.getAnswerOnCurrentQuestion().answer : null;
      },
      getQuestionStatus(index) {
        let isAnswered = false;

        for (const question of this.answeredQuestions) {
          if (question.index === index) {
            isAnswered = true;
            break;
          }
        }

        return isAnswered;
      },
      getAnswersOfQuestion(question) {
        const answers = {};

        for (const prop in question) {
          if (/^answer\d+/.test(prop) && this.currentQuestion[prop]) {
            answers[prop] = this.currentQuestion[prop];
          }
        }

        return answers;
      },
      getAnswerOnCurrentQuestion() {
        let answeredQuestion = null;

        for (const question of this.answeredQuestions) {
          if (question.index === this.currentQuestionIndex) {
            answeredQuestion = question;
            break;
          }
        }

        return answeredQuestion;
      },
      getQuestionResult(index) {
        const result = {
          className: 'empty',
          text: 'Ответ отсутствует',
        };

        for (const question of this.answeredQuestions) {
          if (question.index === index) {
            result.className = question.correct ? 'right' : 'failed';
            result.text = question.correct ? 'Верный ответ' : 'Ошибка';
            break;
          }
        }

        return result;
      },
      getAdditionQuestions() {
        const getAdditionQuestionQueries = [];

        for (const errorQuestion of this.idsForAdditionalQuestions) {
          getAdditionQuestionQueries.push(
            this.$store.dispatch('getSimulatorAdditionalQuestion', {
              examId: 1,
              collectionId: 1,
              questionId: errorQuestion.questionId,
            }),
          );
        }

        this.$store.dispatch('clearQuestions');
        this.answeredQuestions = [];
        this.rightQuestions = [];
        this.currentFocusedIndex = 0;

        Promise.all(getAdditionQuestionQueries)
          .then(() => {
            this.isAdditionQuestions = true;
            this.result.show = false;
            this.result.modal = null;
            this.isAdditionQuestions = true;
            this.questionsLineColors = this.idsForAdditionalQuestions.map(question => question.block);
            this.initQuestions();
          });
      },
      showFailedQuestions() {
        this.$store.dispatch('setSimulatorWrongQuestions', this.wrongQuestions);
        window.removeEventListener('keyup', this.keyboardNavigation);
        this.$router.push('/simulator/errors');
      },
      answerOnQuestion(answer) {
        const currentQuestion = this.questions[this.currentQuestionIndex];
        const isAnswerCorrect = answer === this.questions[this.currentQuestionIndex].correct_answer;
        const answeredQuestionData = {
          answer,
          index: this.currentQuestionIndex,
          question: currentQuestion,
          answers: this.getAnswersOfQuestion(this.questions[this.currentQuestionIndex]),
          correct: isAnswerCorrect,
          lineColor: currentQuestion.lineColor,
        };

        this.answeredQuestions.push(answeredQuestionData);

        if (!isAnswerCorrect) {
          this.wrongQuestions.push(answeredQuestionData);
          this.checkErrors();
        } else {
          this.rightQuestions.push(answeredQuestionData);
          this.goToQuestionList();
        }
      },
      checkErrors() {
        let totalErrors = 0;
        const errors = {
          green: [],
          violet: [],
          blue: [],
          orange: [],
        };

        if (this.isAdditionQuestions) {
          this.calculateResults();
          return;
        }

        for (const wrongQuestion of this.wrongQuestions) {
          errors[wrongQuestion.lineColor].push(wrongQuestion);
          totalErrors++;
        }

        for (const line in errors) {
          if (errors[line].length > 1) {
            this.calculateResults();
            return;
          }
        }

        if (totalErrors > 2) {
          this.calculateResults();
          return;
        }

        this.goToQuestionList();
      },
      keyboardNavigation(event) {
        const keys = {
          escape: 'Escape',
          enter: 'Enter',
          space: ' ',
          up: 'ArrowUp',
          down: 'ArrowDown',
          left: 'ArrowLeft',
          right: 'ArrowRight',
        };
        const isQuestionList = !this.currentQuestion;
        const isQuestion = this.currentQuestion;
        const isModal = this.result.modal;

        /* eslint-disable vue/script-indent */
        switch (event.key) {
          case keys.escape: {
            if (isQuestion) {
              this.goToQuestionList();
            } else {
              event.preventDefault();
            }

            break;
          }

          case keys.space: {
            if (isModal) {
              break;
            } else if (isQuestion) {
              if (!this.isQuestionAnswered) {
                this.answerOnQuestion(this.currentAnswer);
              }
            } else if (isQuestionList) {
              this.goToQuestion(
                this.currentFocusedIndex,
                this.getLineColorByIndex(this.currentFocusedIndex),
              );
            }

            break;
          }

          case keys.left: {
            if (isModal) {
              break;
            }

            if (isQuestion) {
              if (this.currentQuestionIndex <= 0) {
                break;
              }

              this.goToQuestion(
                this.currentQuestionIndex - 1,
                this.getLineColorByIndex(this.currentQuestionIndex - 1),
              );
            } else if (isQuestionList) {
              const excludedIndexes = [0, 1, 2, 3, 4];
              if (!excludedIndexes.includes(this.currentFocusedIndex)) {
                this.currentFocusedIndex -= 5;
              }
            }
            break;
          }

          case keys.right: {
            if (isModal) {
              break;
            }

            if (isQuestion) {
              if (this.currentQuestionIndex >= this.questions.length - 1) {
                break;
              }

              this.goToQuestion(
                this.currentQuestionIndex + 1,
                this.getLineColorByIndex(this.currentQuestionIndex + 1),
              );
            } else if (isQuestionList) {
              const excludedIndexes = [15, 16, 17, 18, 19];
              if (!excludedIndexes.includes(this.currentFocusedIndex)) {
                this.currentFocusedIndex += 5;
              }
            }
            break;
          }

          case keys.up: {
            if (isModal) {
              break;
            }
            if (isQuestionList) {
              const excludedIndexes = [0, 5, 10, 15];
              if (!excludedIndexes.includes(this.currentFocusedIndex)) {
                this.currentFocusedIndex -= 1;
              }
            }
            if (isQuestion && !this.currentAnswer) {
              this.currentAnswer = Object.entries(this.getAnswersOfQuestion(this.currentQuestion))[0][0];
              this.$nextTick(() => {
                this.$refs['question-input-1'][0].focus();
              });
            }

            break;
          }

          case keys.down: {
            if (isModal) {
              break;
            }

            if (isQuestionList) {
              const excludedIndexes = [4, 9, 14, 19];
              if (!excludedIndexes.includes(this.currentFocusedIndex)) {
                this.currentFocusedIndex += 1;
              }
            }

            if (isQuestion && !this.currentAnswer) {
              this.currentAnswer = Object.entries(this.getAnswersOfQuestion(this.currentQuestion))[0][0];
              this.$nextTick(() => {
                this.$refs['question-input-1'][0].focus();
              });
            }

            break;
          }

          default: {
            break;
          }
        }
      },
      endExam() {
        this.$router.push('/simulator/rules');
      },
    },
    created() {
      this.getQuestions();
    },
    mounted() {
      window.addEventListener('keyup', this.keyboardNavigation);
    },
    watch: {
      currentQuestion(val) {
        if (val === null) {
          this.$nextTick(() => {
            this.$refs[`question-${this.currentFocusedIndex}`][0].focus();
          });
        }
      },
      currentFocusedIndex() {
        this.$refs[`question-${this.currentFocusedIndex}`][0].focus();
      },
      /* eslint-disable object-shorthand */
      'result.modal'(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs['modal-button'].focus();
          });
        }
      },
    },
  };
</script>
